export default "__VITE_ASSET__0OP6SDC3__"